import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0625 5.9375C10.0625 4.37891 9.21484 2.95703 7.875 2.16406C6.50781 1.37109 4.83984 1.37109 3.5 2.16406C2.13281 2.95703 1.3125 4.37891 1.3125 5.9375C1.3125 7.52344 2.13281 8.94531 3.5 9.73828C4.83984 10.5312 6.50781 10.5312 7.875 9.73828C9.21484 8.94531 10.0625 7.52344 10.0625 5.9375ZM9.21484 10.4219C8.23047 11.1875 7 11.625 5.6875 11.625C2.54297 11.625 0 9.08203 0 5.9375C0 2.82031 2.54297 0.25 5.6875 0.25C8.80469 0.25 11.375 2.82031 11.375 5.9375C11.375 7.27734 10.9102 8.50781 10.1445 9.49219L13.8086 13.1289C14.0547 13.4023 14.0547 13.8125 13.8086 14.0586C13.5352 14.332 13.125 14.332 12.8789 14.0586L9.21484 10.4219Z",
		fill: "white",
		fillOpacity: .5
	})
});
export { SvgSearch as ReactComponent };
